<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/178poz3/tc-custom/9780446550192.jpg?1737640606167" alt="This image is the cover for the book Future Homemakers of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Future Homemakers of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A . . . funny and wry portrait of six women friends from WWII to the 1990s. . . . By the end, readers will. . . . be shedding tears of sheer recognition.” —</b><i><b>Publishers Weekly</b></i></p><p>Stationed at a U.S. Air Force base in Norfolk, England in 1952, a group of “Yankee wives” are thrown together by nothing more than husbands who patrol the skies keeping the Soviets at bay. They seem to have little in common; some, like Pie Crust Queen Betty Gillis, are content to clip coupons and bake chocolate brownies, while others, like good-time girl Lois Moon, look for a little excitement beyond the perimeter fence. But the women soon discover similarities, from a common fear for their husbands to a desire to help out the war-ravaged British natives. Through marriage and divorce, separations and reunions, the gang will try to hold fast to each other in a story that takes us to the heart of female friendship— and reveals the secret of the perfect Three Color Refrigerator Cake.</p><p>“Fans of such novels as Rebecca Wells's <i>Divine Secrets of the Ya-Ya Sisterhood</i>, Maeve Binchy's <i>Circle of Friends</i>, Terry McMillan's <i>Waiting To Exhale . . . </i>will relish the humor and pathos, as well as the well-defined characters." —<i>Library Journal</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Graham
      </h2>
      
      <p class="authorDescription body article">Laurie Graham is a journalist, scriptwriter and novelist. She lives in County Dublin, Ireland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fourth Estate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?120dfa63